<main id="disabled" class="h-screen w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    <div class="header-wr">
      <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg" [attr.alt]="'LOGIN.LOGO_ALT' | translate">
      <br>
      <h3 class="text-center mt-2 mb-2">{{ 'LOGIN.ROLE_DISABLED_TITLE' | translate }}</h3>
      <p class="text-center mb-8">{{ 'LOGIN.ROLE_DISABLED' | translate }}</p>
    </div>
    <div class="form-wr">
      <form (keydown)="submitOnPressEnter($event)">
        <div class="btn-wr mt-5">
          <button id="login-btn" class="btn primary-btn w-full" (click)="login()">{{ 'LOGIN.LOGIN' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</main>

